// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Hp-z","breadcrumbForward":"Ip-z","breadcrumbBack":"Jp-z","selected":"Kp-z"};